import styled from 'styled-components'
import {
  textStyleSizeOptions,
  textStyleWeightOptions,
  textStyleSizeStyleOptions,
  textStyleWeightStyleOptions
} from '../stories/fundamentals/text-styles/constants'

export const H1 = styled.h1`
  font-weight: normal;
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-XXL']]};
  margin-top: 38px;
  word-wrap: break-word;
  @media (max-width: 767px) {
    margin-top: 6px;
    ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-XL']]};
    white-space: ${({ wrapLine }) => (wrapLine ? 'normal' : 'nowrap')};
    overflow: hidden;
    text-overflow: ellipsis;
    ${({ maxWidth }) => (maxWidth ? `max-width: ${maxWidth};` : '')}
  }
`
